<template>
<div>
	 <v-dialog title="新增老师" v-model="hideShow" width="600" persistent scrollable>
		<v-card class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-cog-outline</v-icon></span><div class="mg-dialog-title"><h2><span>新增老师</span></h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭新增老师" @click="cancel"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-row dense>
					<v-col cols="12" sm="6">
						<v-text-field label="老师昵称" placeholder="例如:李老师/苹果老师" v-model="add.employee.nickName" dense outlined color="#d9363e" aria-label="老师昵称"></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field label="老师姓名" placeholder="请输入老师真实姓名" v-model="add.employee.trueName" dense outlined color="#d9363e" aria-label="老师姓名"></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field label="手机号" placeholder="登录系统的手机号" v-model="add.employee.mobile" dense outlined color="#d9363e" aria-label="手机号"></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field v-if="add.employee.canLogin" label="登录密码" v-model="add.employee.password"
							dense outlined color="#d9363e" aria-label="登录密码"></v-text-field>
					</v-col>
					<v-col cols="8">
						<v-select v-model="add.employee.shopIds" :items="selectShopList" label="指定所属校区" multiple
							placeholder="多个校区任课,请选择多个校区"
							item-text="shopName" item-value="id" outlined dense color="#d9363e" aria-label="指定所属校区"></v-select>
					</v-col>
					<v-col cols="4">
						<v-switch v-model="add.employee.isTeacher" class="mt-1" color="green lighten-2"
							hide-details label="是否代课"></v-switch>
					</v-col>
					<v-col cols="12" class="mt-n3">
						<span style="color: red;">以下项目为非必填项:</span>
					</v-col>
					<v-col cols="12">
						<!-- 上传图片组件 -->
						<!-- <uploadPhoto :show="hideShow" title="上传老师头像" @success="uploadSuccess"></uploadPhoto> -->
						<!-- 上传图片组件 -->
						<cutImageUpload :show="hideShow" title="上传老师头像"  @success="uploadSuccess"></cutImageUpload>
					</v-col>

				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="cancel" depressed>取消</v-btn>
				<v-btn @click="submitAddEmployee" color="#d9363e" depressed class="fc-confirm">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
 </div>
</template>

<script>

	import utils from "../config/utils"
	import md5 from "js-md5"
	import cutImageUpload from "./cut_image_upload.vue"
	export default {
		name:"create-teacher",
		components:{cutImageUpload},
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
		},
		watch:{
			show(newVal,oldVal){
			
				this.hideShow = newVal;
				if(this.hideShow){
					// 显示时 
				
					
					// 清空历史数据
					this.add.employee.shopIds = [];
					this.add.employee.avatar = "";
					this.add.employee.nickName = "";
					this.add.employee.mobile = "";
					this.add.employee.trueName = "";
					this.add.employee.password = "";
					this.add.employee.isTeacher = true;
					
				}
			}
		},
		data(){
			return {
				add: {
					dialog: false,
					employee: {
						trueName: "",
						nickName: "",
						avatar: "",
						mobile: "",
						canLogin: true,
						password: "",
						shopIds: [],
						isTeacher:true,
					},
				},
				selectShopList:[],
				hideShow:this.show
			}
		},
		mounted() {
			this.getShopListForSelect();
			console.log("create-teacher-com mounted");
		},
		methods:{
			
			uploadSuccess(e){
				this.add.employee.avatar = e.key;
			},
			
			cancel(){
				this.$emit("cancel","");
			},
			submitAddEmployee() {
			
				if (!this.add.employee.nickName) {
					this.$noty.error('昵称不能为空');
					return
				}
				if (!this.add.employee.trueName) {
					this.$noty.error('姓名不能为空');
					return
				}
				if (!this.add.employee.mobile) {
					this.$noty.error('手机号不能为空');
					return
				}
				if (!this.add.employee.password) {
					this.$noty.error('请输入登录密码');
					return
				}
			
			
				if (this.add.employee.shopIds.length == 0) {
					this.$noty.error('请选择员工校区');
					return
				}
			
				// api
				const that = this;
				let url = `/sys/employee/create`;
				let postData = {
					...this.add.employee
				};
			
				if (this.add.employee.canLogin) {
					postData.password = md5(postData.password);
				}
				postData.canLogin = postData.canLogin == true ? "1" : "0";
				postData.isTeacher = postData.isTeacher == true ? "1" : "0";
				
			
			
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							
							that.$emit("success","");
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
			
				});
			
			},
			getShopListForSelect() {
				const that = this;
				let url = `/sys/merchant/shop/list`;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectShopList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
	
</script>
<style>
</style>
<style lang="scss" scoped src="../assets/styles/management.scss"></style>
